module.exports = __webpack_public_path__ + "media/application/images/svgs/truck-2f91ac92d48ea714a75ff89e965110e3.svg";